import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useWindowSize from '~/components/hooks/useWindowSize';
import arrow from '~/images/arrow-right.svg';

const ProductCardSizes = ({ handledProduct }) => {
	const { t } = useTranslation();

	const [showSizes, setShowSizes] = useState(false);
	const { width } = useWindowSize();

	if (handledProduct.sizes == null || handledProduct.sizes.length == 0) {
		return null;
	}

	return (
		<div className="sizes-container">
			<div className={`toggle-sizes ${showSizes ? 'close' : 'show'}`} onClick={() => setShowSizes(!showSizes)}>
				<img className={showSizes ? 'close' : 'show'} src={arrow} alt="Show Sizes Icon" />
			</div>

			{(width > 750 || showSizes) && (
				<div className="sizes">
					{handledProduct.sizes
						.filter(s => s.qty > 0)
						.map((item, index) => (
							<span className={`size ${!item.qty || item.qty <= 0 ? 'disabled' : ''}`} key={handledProduct.id + '-' + index}>
								{item.svtxt}
							</span>
						))}
				</div>
			)}
		</div>
	);
};

ProductCardSizes.propTypes = {
	handledProduct: PropTypes.object
};
export default ProductCardSizes;
